import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import {
  isConsumerArea as selectIsConsumerArea,
  selectCurrentClient,
} from '../../CommonSelectors/CommonAreaSelector';
import { useRouteParams } from './useRouteParams';
import { useBootstrapConsumerArea } from '../../ConsumerArea/hooks/useBootstrapConsumerArea';
import { CONSUMER_AREA_ACCESS_WORKFLOWS } from '../../CommonConstants';
import { WorkflowIdEnum } from '../../Workflow/api/useWorkflowDataQuery';

export const useWorkflowCompleteNavigateAway = () => {
  const { clientId, redirectTo } = useRouteParams();

  const isConsumerArea = useSelector(selectIsConsumerArea);
  const { ConsumerAccessWorkflow: consumerAccessWorkflow } = useSelector(selectCurrentClient);

  const { mutateAsync: bootstrapConsumerArea, isLoading } = useBootstrapConsumerArea();

  const navigateAway = useCallback(async () => {
    if (redirectTo === 'profile') {
      ADV.util.Router.go2('ProfileRiskTolerance', { clientId });
    } else if (redirectTo === 'comprehensive' || redirectTo === 'assetBucketing') {
      ADV.util.Router.go2('Workflow', {
        clientId,
        workflowId:
          redirectTo === 'assetBucketing'
            ? WorkflowIdEnum.AssetBucketing
            : WorkflowIdEnum.Comprehensive,
        stepId: 10,
        pivotId: 0,
        pageId: 'risktolerance',
      });
    } else {
      try {
        if (isConsumerArea) {
          const { componentName } = await bootstrapConsumerArea({
            clientId,
            completedWorkflow: true,
          });

          let outputRoute = componentName || 'ClientEditPlan';

          if (
            outputRoute === 'NewFinancialPlanWhatIfs' &&
            consumerAccessWorkflow === CONSUMER_AREA_ACCESS_WORKFLOWS.ALL_WORKFLOWS
          ) {
            outputRoute = 'ClientEditPlan';
          }

          ADV.util.Router.go2(outputRoute, { clientId });
        } else {
          ADV.util.Router.go2('ClientEditPlan', { clientId });
        }
      } catch (err) {
        console.error(err);
      }
    }
  }, [bootstrapConsumerArea, clientId, consumerAccessWorkflow, isConsumerArea, redirectTo]);

  return {
    navigateAway,
    isLoading,
  };
};
